import React from 'react'
import { protoString } from "../../helper";
import {
    H5,
    Intent,
    Button,
} from "@blueprintjs/core";

const ProtocolCard = ({ selected, imgSrc, protocol, desc, chooseCard, demoLink }) => {
    return (
        <div
            className={selected ? 'selectedProtoCard' : 'protoCard'}
            onClick={chooseCard}
            id={protocol}
        >
            <img src={imgSrc}
                alt="proto1"
                id={protocol}
                className='img-responsive'
                style={{ width: "30%", marginLeft: "35%", zIndex: "-200" }} />
            <H5
                className='text-center'
                id={protocol}
            >{protoString(protocol)}</H5>
            <p className='protoDesc'
                id={protocol}
                onClick={chooseCard}
            >
                {desc}
            </p>
            <div className="text-center margin-bottom-large">
                <Button onClick={chooseCard} intent={Intent.PRIMARY}>Select protocol</Button>
            </div>

            {/* <div className="text-center margin-bottom-large">
                <Button intent={Intent.PRIMARY}><a className='exempleLink' href={demoLink}>See Demo</a></Button>
            </div> */}
        </div>

    )
}

export default ProtocolCard
